import UserSingleSelect from "@/components/form/user-single-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import { MANAGER_ROLE_KEYS } from "@/libs/user-role";

type ManagerFieldExtraProps = {
  placeholder?: string;
  align?: "start" | "center" | "end";
};

/** Searchable manager picker. **Value is a user id** (`string | null`). */
export type ManagerFieldProps = PickerFieldProps<
  string | null,
  ManagerFieldExtraProps
>;

export const ManagerField = makePickerField<
  string | null,
  ManagerFieldExtraProps
>({
  name: "ManagerField",
  control: UserSingleSelect,
  popout: true,
  controlProps: (props) => ({
    params: {
      roles: { in: MANAGER_ROLE_KEYS.join(",") },
      isActivated: "true",
    },
    placeholder: props.placeholder,
    align: props.align,
  }),
});
